// extracted by mini-css-extract-plugin
export default {"root":"Download__root--t50K3","image-holder":"Download__image-holder--AVzMd","imageHolder":"Download__image-holder--AVzMd"};